/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { dialogApi, dialogTypes } from "components/dialogs";
import * as stores from "stores";
import { isValidPageNum } from "utils/MathUtils";

const handleGoToPage = pageNumber => {
  pageNumber = Number(pageNumber);
  if (!isValidPageNum(pageNumber)) {
    dialogApi.setDialogHasError(true);
  } else {
    dialogApi.hide();
    stores.pagedViewState.goToPage(pageNumber);
  }
};

export const openPopUP = totalPages => {
  dialogApi.show(dialogTypes.INPUT_DIALOG, {
    onSubmit: handleGoToPage,
    onChange: () => {
      dialogApi.setDialogHasError(false);
    },
    onCancel: () => {
      dialogApi.hide();
    },
    localeStrings: {
      primaryText: {
        str: "dialog.goToPage.text",
        values: {
          totalPages
        }
      },
      secondaryText: "dialog.goToPage.incorrect",
      title: "dialog.goToPage.title",
      confirmLabel: "dialog.goToPage.input.submit",
      cancelLabel: "common.cancel",
      placeholder: ""
    },
    dialogType: "number"
  });
};
